export default "__VITE_ASSET__09dfuUuF__"